export default __webpack_public_path__ + "static/media/CXO.b217c3ed.png";